import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/adserver';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async selWebsites(params: any) {
    return api.selWebsites(params);
  }

  @Action
  async websites(params: any) {
    return api.websites(params);
  }

  @Action
  async addWebsite(params: any) {
    return api.addWebsite(params);
  }

  @Action
  async editWebsite(params: any) {
    return api.editWebsite(params);
  }

  @Action
  async detailWebsite(params: any) {
    return api.detailWebsite(params);
  }

  @Action
  async deleteWebsite(params: any) {
    return api.deleteWebsite(params);
  }

  @Action
  async zones(params: any) {
    return api.zones(params);
  }

  @Action
  async addZone(params: any) {
    return api.addZone(params);
  }

  @Action
  async editZone(params: any) {
    return api.editZone(params);
  }

  @Action
  async detailZone(params: any) {
    return api.detailZone(params);
  }

  @Action
  async deleteZone(params: any) {
    return api.deleteZone(params);
  }

  @Action
  async banners(params: any) {
    return api.banners(params);
  }

  @Action
  async addBanner(params: any) {
    return api.addBanner(params);
  }

  @Action
  async editBanner(params: any) {
    return api.editBanner(params);
  }

  @Action
  async detailBanner(params: any) {
    return api.detailBanner(params);
  }

  @Action
  async deleteBanner(params: any) {
    return api.deleteBanner(params);
  }

  @Action
  async deliveryOptions(params: any) {
    return api.deliveryOptions(params);
  }

  @Action
  async saveDeliveryOptions(params: any) {
    return api.saveDeliveryOptions(params);
  }

  @Action
  async selZones(params: any) {
    return api.selZones(params);
  }

  @Action
  async trackers(params: any) {
    return api.trackers(params);
  }
}
